export default function (context, val) {
    let name = val;
    context.state[name].visible = true;
}